/**
 * i18n - 基于插件的自动语言检测Store
 * @author wwl
 * @created 2024/10/27
 * @modified 2024/10/27
 */
import { defineStore } from 'pinia'
import { ELocale } from '~~/types/enums'

export const useI18nStore = defineStore('i18n', {
  state: (): { locale: ELocale } => ({
    locale: ELocale.cn // 默认中文
  }),

  getters: {
    // 从插件获取检测到的语言
    detectedLanguage(): 'cn' | 'en' {
      try {
        const nuxtApp = useNuxtApp()
        return nuxtApp.$detectedLanguage || 'cn'
      } catch (error) {
        console.log('[app/stores/i18n.ts:21]', error)
        return 'cn'
      }
    }
  },

  actions: {
    setLang(data: ELocale) {
      // 🔧 优先使用插件检测的语言，但保持接口兼容性
      try {
        const nuxtApp = useNuxtApp()
        const detectedLanguage = nuxtApp.$detectedLanguage

        if (detectedLanguage === 'en') {
          this.locale = ELocale.en
        } else {
          this.locale = ELocale.cn
        }

        //console.log(`[useI18nStore] 🔧 从插件获取语言: ${detectedLanguage}, 设置locale: ${this.locale}`)
      } catch (error) {
        // 降级：使用传入参数
        this.locale = data
        console.log(`[useI18nStore] 降级模式，使用传入参数: ${data}`, error)
      }
    },

    // 初始化方法
    initFromPlugin() {
      this.setLang(ELocale.cn) // 触发检测
    }
  }
})
